export default "__VITE_ASSET__06bf5d29__"